import FeaturesPopupContainer from "./FeaturesPopupContainer";

export default FeaturesPopupContainer;
